<div class="bg-purple-100 m-10 p-10">
    <div class="container mx-auto px-4 py-8 ">
        <div>  
             <h1 class="text-3xl font-bold mb-4">Privacy Policy</h1>
             <p>Last updated: 21 may 2024</p>
             </div>


        <p class="mt-4">
            Welcome to VinMarts! This privacy policy explains how we collect, use, disclose, and safeguard your information when you visit our website vinmarts.in, use our mobile application, or engage with us through any other means.
        </p>

        <h2 class="text-2xl font-bold mb-2">Information We Collect</h2>

        <p class="mb-4">
            We may collect and process the following data about you:
        </p>

        <ul class="list-disc list-inside mb-4">
            <li>Personal Identification Information: Name, email address, phone number, etc.</li>
            <li> Payment Information: Credit card details, billing address, etc.</li>
            <li>Transaction Information: Details about purchases, transaction amounts, etc.</li>
            <li>Technical Information: IP address, browser type, operating system, etc.</li>
            <li>Usage Data: Information about how you use our website, products, and services.</li>
        </ul>

        <h2 class="text-2xl font-bold mb-2">How We Use Your Information</h2>

        <p class="mb-4">
            We use the information we collect in various ways, including to:
        </p>

        <ul class="list-disc list-inside mb-4">
            <li>Provide, operate, and maintain our website</li>
            <li>Improve, personalize, and expand our website</li>
            <li>Understand and analyze how you use our website</li>
            <li>Process your transactions and manage your orders</li>
            <li>Communicate with you, either directly or through one of our partners, including for customer service, to provide you with updates and other information relating to the website, and for marketing and promotional purposes</li>
            <li>Send you emails</li>
            <li>Find and prevent fraud</li>
           
        </ul>

        <h2 class="text-2xl font-bold mb-2">Refund Policy</h2>

        <p class="mb-4">
            At VinMarts, we strive to ensure your complete satisfaction with your purchase. If you are not entirely satisfied with your purchase, we’re here to help.
        </p>
        <ul class="list-disc list-inside mb-4">
            <li><b>Returns:</b> You have 7 calendar days to return an item from the date you received it. To be eligible for a return, your item must be unused and in the same condition that you received it. Your item must be in the original packaging and you need to provide the receipt or proof of purchase.</li>
            <li><b>Refunds:</b> Once we receive your item, we will inspect it and notify you that we have received your returned item. We will immediately notify you of the status of your refund after inspecting the item. If your return is approved, we will initiate a refund to your credit card (or original method of payment). You will receive the credit within 7 number of days, depending on your card issuer’s policies.</li>
            <li><b>Shipping:</b> You will be responsible for paying for your own shipping costs for returning your item. Shipping costs are non-refundable.</li>
            </ul>

        <h2 class="text-2xl font-bold mb-2">Shipping Policy</h2>

        <p class="mb-4">
            Thank you for visiting and shopping at VinMarts. Following are the terms and conditions that constitute our Shipping Policy.
        </p>
        <ul class="list-disc list-inside mb-4">
            <li><b>Shipment Processing Time</b> All orders are processed within [2-3] business days. Orders are not shipped or delivered on weekends or holidays.</li>
            <li><b>Shipping Rates & Delivery Estimates: </b> Shipping charges for your order will be calculated and displayed at checkout. Delivery delays can occasionally occur.</li>
            <li><b>Shipping Timeframe:</b> Products will be shipped within 7 to 12 days after processing. </li>
            <li><b>Shipment Confirmation & Order Tracking: </b> You will receive a Shipment Confirmation email once your order has shipped containing your tracking number(s). The tracking number will be active within 24 hours.</li>
            <li><b>Customs, Duties, and Taxes:</b>VinMarts is not responsible for any customs and taxes applied to your order. All fees imposed during or after shipping are the responsibility of the customer (tariffs, taxes, etc.). </li>
            <li><b>Damages:</b>VinMarts is not liable for any products damaged or lost during shipping. If you received your order damaged, please contact the shipment carrier to file a claim. Please save all packaging materials and damaged goods before filing a claim.</li>
              </ul>
       
        <h2 class="text-2xl font-bold mb-2">Sharing Your Information</h2>

        <p class="mb-4">
            We may share your information with third parties in the following situations:
        </p>

        <ul class="list-disc list-inside mb-4">
            <li><b>Service Providers:</b> We may share your information with third-party service providers who perform services on our behalf, such as payment processing, data analysis, email delivery, hosting services, customer service, and marketing assistance.</li>
            <li><b>Business Transfers:</b> We may share or transfer your information in connection with, or during negotiations of, any merger, sale of company assets, financing, or acquisition of all or a portion of our business to another company.</li>
            <li><b>Legal Requirements:</b>We may disclose your information where we are legally required to do so in order to comply with applicable law, governmental requests, a judicial proceeding, court order, or legal process.</li>
            
        </ul>
        <h2 class="text-2xl font-bold mb-2">Your Data Protection Rights</h2>

        <p class="mb-4">
            Depending on your location, you may have the following rights regarding your personal data: </p>

        <ul class="list-disc list-inside mb-4">
            <li>The right to access – You have the right to request copies of your personal data. </li>
            <li>The right to rectification – You have the right to request that we correct any information you believe is inaccurate or complete information you believe is incomplete. </li>
            <li>The right to erasure – You have the right to request that we erase your personal data, under certain conditions. </li>
            <li>The right to restrict processing – You have the right to request that we restrict the processing of your personal data, under certain conditions. </li>
            <li> The right to object to processing – You have the right to object to our processing of your personal data, under certain conditions.</li>
            <li> The right to data portability – You have the right to request that we transfer the data that we have collected to another organization, or directly to you, under certain conditions.</li>

        </ul>

        <h2 class="text-2xl font-bold mb-2">Security of Your Information</h2>
        <p class="mb-4">
            We use administrative, technical, and physical security measures to help protect your personal information. While we have taken reasonable steps to secure the personal information you provide to us, please be aware that despite our efforts, no security measures are perfect or impenetrable, and no method of data transmission can be guaranteed against any interception or other type of misuse.
        </p>

        <h2 class="text-2xl font-bold mb-2">Changes to This Privacy Policy</h2>
        <p class="mb-4">
            We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page. You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.    
        </p>
        <h2 class="text-2xl font-bold mb-2">Contact Us</h2>
        <p class="mb-4">
            If you have any questions about this Privacy Policy, please contact us:    
        </p>

        <ul class="list-disc list-inside mb-4">
            <li>By email: contact&#64;vinmarts.in</li>
            <li>By visiting this page on our website: vinmarts.in/contact</li>
            <li>By phone number: +917987293301</li>
        </ul>
    </div>
</div>